import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DisplayComponent } from './components/display/display.component';
import { TerminateComponent } from './components/terminate/terminate.component';

const routes: Routes = [
  {
    path: 'terminate',
    component: TerminateComponent
  },
  {
    path: '',
    component: DisplayComponent
  }
];
@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
